export const AI_COLORED_STAR_ICON = "https://dapulse-res.cloudinary.com/image/upload/Subtract.svg";
